import {
  CasEntityRHFSelect,
  CasEntitySelect,
  componentProps,
  CasEntitySelectProps,
} from 'src/compass/shared/components';

const entity = 'User/Select';

export function CasRHFUserSelect(props: CasEntitySelectProps) {
  return CasEntityRHFSelect(entity, props);
}

export function CasUserSelect(props: componentProps) {
  return CasEntitySelect(entity, props);
}
